import { useEffect } from 'react';

export function useElementEvent(ele, event, handler) {
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (ele) {
      ele.addEventListener(event, handler);

      return () => {
        ele.removeEventListener(event, handler);
      };
    }
  }, [ele, event, handler]);
}
